
import { setLoading } from "../../Redux/slices/globalSlice";
import { enqueueSnackbar } from 'notistack';

export const HandleLoading = (status) => {
    return async (dispatch) => {
        try {
            dispatch(setLoading(status));
        } catch (e) {}
    }
}